module.exports = __webpack_public_path__ + "static/media/next_white.8bc4e34f.svg";